import { render, staticRenderFns } from "./OrphanAdmin.vue?vue&type=template&id=29ec0460&scoped=true"
import script from "./OrphanAdmin.vue?vue&type=script&lang=js"
export * from "./OrphanAdmin.vue?vue&type=script&lang=js"
import style0 from "./OrphanAdmin.vue?vue&type=style&index=0&id=29ec0460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec0460",
  null
  
)

export default component.exports